import { Typography } from 'antd';
import { FC } from 'react';

import { BaseQueryParams } from '@/common/interfaces';

import { useAutocompleteSearchAndReplaceQuery } from '@/modules/Pages';

const { Text } = Typography;

interface Props {
  autocompleteData: BaseQueryParams<typeof useAutocompleteSearchAndReplaceQuery>['data'] | undefined;
  autocompleteIsLoading: boolean;
  autocompleteIsFetching: boolean;
  autocompleteIsError: boolean;
  autocompleteError: BaseQueryParams<typeof useAutocompleteSearchAndReplaceQuery>['error'] | null;
}

export const PagesSearchAndReplaceFormAutocompleteLabel: FC<Props> = ({
  autocompleteData,
  autocompleteIsLoading,
  autocompleteIsFetching,
  autocompleteIsError,
  autocompleteError,
}) => {
  if (autocompleteIsFetching || autocompleteIsLoading)
    return (
      <Text type="secondary" italic>
        Завантаження...
      </Text>
    );

  const message = Array.isArray(autocompleteError?.response?.data.message)
    ? autocompleteError.response.data.message[0].errors[0]
    : autocompleteError?.response?.data.message;

  if (autocompleteIsError)
    return (
      <Text type="danger" italic>
        Помилка: {message || 'Щось пішло не так'}
      </Text>
    );

  if (autocompleteData)
    return (
      <Text italic type="secondary">
        {`${autocompleteData.totalWordsCount} результатів у ${autocompleteData.pagesCount} сторінках`}
      </Text>
    );

  if (autocompleteData === undefined)
    return (
      <Text type="secondary" italic>
        Введіть текст для пошуку, щоб побачити кількість результатів
      </Text>
    );
};
